// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { sprintf } from 'sprintf-js';
import { isDefined } from 'utils/functional';
import SearchEmptyResultsMessage from 'components/SearchEmptyResultsMessage';
import Link from 'components/Link';
import { fetchListingCounts as fetchListingCountsRaw } from '../redux/main/actions/listingCounts';

const { useEffect } = React;

const getMessage = (count, query, location, clearSearchLocation) => {
  const linkText = /* TRANSLATORS: "results" around the world! (shown as call to action when no results available) */ sprintf(
    getText('%(count)s graduate programs around the world! '),
    { count: count.toLocaleString(USER_LOCALE) }
  );

  const makeClearLocationLink = () => (
    <Link
      href="#"
      data-qa-id="grad-search-no-results-clear-location"
      onClick={() => {
        clearSearchLocation(false);
      }}
    >
      {linkText}
    </Link>
  );

  return (
    <>
      {/* TRANSLATORS: search: no results message */ getText(
        "We didn't find anything for your search, but there are "
      )}
      {makeClearLocationLink()}
    </>
  );
};

type OwnProps = {|
  query?: string,
  searchLocation: SearchLocation,
  clearSearchLocation: Function
|};

type Props = {|
  ...OwnProps,
  fetchListingCounts: Object => void,
  listingCounts: { [string]: number }
|};

const GradSchoolsSearchEmptyResultsMessage = ({
  query,
  searchLocation,
  clearSearchLocation,
  fetchListingCounts,
  listingCounts
}: Props) => {
  useEffect(
    () => {
      fetchListingCounts({
        indices: ['MAIN_SEARCH']
      });
    },
    [fetchListingCounts]
  );
  return (
    <SearchEmptyResultsMessage
      query={query}
      resultType="graduate programs"
      additionalMessage={
        searchLocation &&
        searchLocation.text &&
        listingCounts &&
        isDefined(listingCounts.GRAD_PROGRAM) &&
        getMessage(
          listingCounts.GRAD_PROGRAM,
          query,
          searchLocation,
          clearSearchLocation
        )
      }
      searchLocation={searchLocation}
      clearSearchLocation={clearSearchLocation}
    />
  );
};

export default connect<Props, OwnProps, _, _, _, _>(
  ({ listingCounts }) => ({ listingCounts }),
  { fetchListingCounts: fetchListingCountsRaw }
)(GradSchoolsSearchEmptyResultsMessage);
